/**
 * Centralized place-related localStorage keys.
 * Cleared on logout so the next user does not see the previous user's place.
 */
export const PLACE_ID_LOCALSTORAGE_KEY = 'wortelogy-menu-place-id'

export function clearPlaceStorage(): void {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.removeItem(PLACE_ID_LOCALSTORAGE_KEY)
  } catch {
    // ignore
  }
}
